import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PaymentState } from './payment.state';

export const selectPaymentState = createFeatureSelector<PaymentState>('paymentStore');

export const selectPaymentSession = createSelector(
    selectPaymentState,
    (state: PaymentState) => state.paymentSession
);

export const selectCreditCardToken = createSelector(
    selectPaymentState,
    (state: PaymentState) => state.patientCreditCardToken
);

export const selectCreditCardTokenResponse = createSelector(
    selectPaymentState,
    (state: PaymentState) => state.creditCardTokenResponse
);

export const selectPaymentStateEvents = createSelector(
    selectPaymentState,
    (state: PaymentState) => state.paymentStateEvents
);

export const selectPaymentRequest = createSelector(
    selectPaymentState,
    (state: PaymentState) => state.paymentRequest
);

export const selectPaymentresponse = createSelector(
    selectPaymentState,
    (state: PaymentState) => state.paymentResponse
);

export const selectInvoiceresponse = createSelector(
    selectPaymentState,
    (state: PaymentState) => state.invoiceResponse
);

export const selectPaymentToken = createSelector(
    selectPaymentState,
    (state: PaymentState) => state.paymentToken
);